import React, { Fragment, useContext, useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import ThemeProvider from '@mui/system/ThemeProvider';
import Grid from '@mui/material/Unstable_Grid2';
import NavBar from './components/layout/NavBar';
import { Project } from './types/project';
import './App.scss';
import theme from './theme/theme';
import UserProjects from './components/project/UserProjects';
import ProjectDetails from './components/project/ProjectDetails';
import NewDetailsPage from './components/project/NewDetailsPage';
import ProjectNavbar from './components/layout/ProjectNavbar';
import ServiceAreas from './components/project/ServiceAreas';
import AuthContext from './context/auth/AuthContext';
import ProjectContext from './context/project/ProjectContext';
import ProjectInformation from './components/project/ProjectInformation';
import AlertContext from './context/alert/AlertContext';
import AlertDialog from './components/common/AlertDialog';
import Alert from './components/common/Alert';
import UpdateUnitsConfig from './components/project/UpdateUnitsConfig';
import QuickLinks from './components/project/QuickLinks';
import esriConfig from '@arcgis/core/config';
// import esriId from "@arcgis/core/identity/IdentityManager";
// import Portal from "@arcgis/core/portal/Portal";
// import { initialize, checkCurrentStatus, signIn, fetchUser } from "./oauth";
// import IdentityManager from "@arcgis/core/identity/IdentityManager";
import Loader from './components/common/Loader';
import UpdateRolesConfig from './components/project/UpdateRolesConfig';
import UpdateServiceArea from './components/project/UpdateServiceArea';
import ConfigNavbar from './components/layout/ConfigNavbar';
import UpdateIntelliFiberRolesConfig from './components/settings/UpdateIntelliFiberRolesConfig';
import UpdateIntelliFiberUnitsConfig from './components/settings/UpdateIntelliFiberUnitsConfig';
import UpdateIntelliFiberClientsConfig from './components/settings/UpdateIntelliFiberClientsConfig';
import UpdateIntelliFiberClientsUserConfig from './components/settings/UpdateIntelliFiberClientsUserConfig';
import UpdateIntelliFiberClientGroupConfig from './components/settings/UpdateIntelliFiberClientGroupConfig';

function App() {
  const projectContext = useContext(ProjectContext);
  const authContext = useContext(AuthContext);
  const alertContext = useContext(AlertContext);
  const {
    projects,
    intelliFiberRoles,
    intelliFiberUserRoles,
    intelliFiberProjectUserRoles,
    getPhases,
    permissions,
    rolePermissions,
    getProjectsV2,
    loading,
    getServiceAreasV2,
    getAllServiceAreasV2,
    getAssetLookupV2,
    getRolesV2,
    addRoleV2,
    getProjectServiceAreasV2,
    getEnterpriseUsersV2,
    getAssetGroupsV2,
    getAssetTypesV2,
    getIntelliFiberRoles,
    getIntelliFiberUserRoles,
    getProjectUserRoles,
    getPemissions,
    getRolePermissions,
    addIntelliFiberUserRole,
    getAllUserRoles,
  } = projectContext;
  const { loadApp, user } = authContext;

  const {
    show: displayAlert,
    message: alertMessage,
    messageType: messageType,
    title: alertTitle,
    clearAlert,
    ui: alertUI,
    submitAction,
  } = alertContext;

  const [showApp, setShowApp] = useState<boolean>(false);
  const [projectList, setProjectList] = useState<Project[]>([]);
  async function initApp() {
    const signedIn = loadApp ? await loadApp() : false;
    setShowApp(signedIn);
  }

  useEffect(() => {
    // setProjects(projects);
    esriConfig.portalUrl = `${process.env.REACT_APP_PORTAL_URL}`;
    initApp();
    fetchRoles();
    fetchEnterpriseUsers();
    // fetchProjectAssignments();
    fetchAssets();
    fetchAllServiceAreas();
    fetchAssetGroups();
    fetchAssetTypes();
    fetchIntelliFiberRoles();
    fetchIntelliFiberUserRoles();
    fetchProjectUserRoles();
    fetchPemissions();
    fetchRolePermissions();
    fetchProjects();
    fetchClientRoles();
    fetchPhases();
    // addIntelliFiberUserRoles();
    //eslint-disable-next-line
  }, []);

  const fetchProjects = async () => {
    if (getProjectsV2) {
      try {
        const projs = await getProjectsV2();
        console.log('@@Projects:', projs);
      } catch (error) {
        console.log('@@Error:', error);
      }
    }
  };

  const fetchClientRoles = async () => {
    if (getAllUserRoles) {
      try {
        const clientRoles = await getAllUserRoles();
        console.log('@@IFC Roles:', clientRoles);
      } catch (error) {
        console.log('@@Error:', error);
      }
    }
  };

  const fetchAssetGroups = async () => {
    if (getAssetGroupsV2) {
      try {
        const projs = await getAssetGroupsV2();
        console.log('@@AssetGroups:', projs);
      } catch (error) {
        console.log('@@Error:', error);
      }
    }
  };

  const fetchAssetTypes = async () => {
    if (getAssetTypesV2) {
      try {
        const projs = await getAssetTypesV2();
        console.log('@@AssetTypes:', projs);
      } catch (error) {
        console.log('@@Error:', error);
      }
    }
  };

  const fetchRoles = async () => {
    if (getRolesV2) {
      try {
        const roles = await getRolesV2();
        console.log('Roles fetched for proejcts:', roles);
      } catch (error) {
        console.log('@@Error:', error);
      }
    }
  };

  const fetchEnterpriseUsers = async () => {
    if (getEnterpriseUsersV2) {
      try {
        const enterpriseUsers = await getEnterpriseUsersV2();
        console.log('Enterprise Users fetches:', enterpriseUsers);
      } catch (error) {
        console.log('@@Error:', error);
      }
    }
  };

  const fetchAllServiceAreas = async () => {
    if (getAllServiceAreasV2) {
      try {
        await getAllServiceAreasV2();
      } catch (error) {
        console.log('@@Error:', error);
      }
    }
  };

  const fetchAssets = async () => {
    console.log('@@Fetch Assetd:');
    if (getAssetLookupV2) {
      try {
        const assetLookup = await getAssetLookupV2();
        console.log('@@Assetd Lookup:', assetLookup);
      } catch (error) {
        console.log('@@Service Areas Error:', error);
      }
    }
  };

  const fetchUsers = async () => {
    console.log('@@Fetch Users:');
    if (getEnterpriseUsersV2) {
      try {
        const users = await getEnterpriseUsersV2();
        console.log('@@Users Lookup:', users);
      } catch (error) {
        console.log('@@Enterprise Users Fetch Error:', error);
      }
    }
  };

  const fetchIntelliFiberRoles = async () => {
    console.log('@@Fetch IntelliFiberRoles:');
    if (getIntelliFiberRoles) {
      try {
        const users = await getIntelliFiberRoles();
        console.log('@@IntelliFiberRoles Lookup:', users);
      } catch (error) {
        console.log('@@IntelliFiberRoles Fetch Error:', error);
      }
    }
  };

  const fetchIntelliFiberUserRoles = async () => {
    console.log('@@Fetch IntelliFiberUserRoles:');
    if (getIntelliFiberUserRoles) {
      try {
        const users = await getIntelliFiberUserRoles();
        console.log('@@IntelliFiberUserRoles Lookup:', users);
      } catch (error) {
        console.log('@@IntelliFiberUserRoles Fetch Error:', error);
      }
    }
  };

  const fetchProjectUserRoles = async () => {
    console.log('@@Fetch ProjectUserRoles:');
    if (getProjectUserRoles) {
      try {
        const users = await getProjectUserRoles();
        console.log('@@ProjectUserRoles Lookup:', users);
      } catch (error) {
        console.log('@@ProjectUserRoles Fetch Error:', error);
      }
    }
  };

  const fetchPemissions = async () => {
    console.log('@@Fetch Pemissions:');
    if (getPemissions) {
      try {
        const users = await getPemissions();
        console.log('@@Pemissions Lookup:', users);
      } catch (error) {
        console.log('@@Pemissions Fetch Error:', error);
      }
    }
  };

  const fetchRolePermissions = async () => {
    console.log('@@Fetch RolePermissions:');
    if (getRolePermissions) {
      try {
        const users = await getRolePermissions();
        console.log('@@RolePermissions Lookup:', users);
      } catch (error) {
        console.log('@@RolePermissions Fetch Error:', error);
      }
    }
  };

  const fetchPhases = async () => {
    if (getPhases) {
      try {
        const phases = await getPhases();
        console.log('@@Phases:', phases);
      } catch (error) {
        console.log('@@Error:', error);
      }
    }
  };

  const getAccessibleProjects = (lUser): Project[] => {
    //check User's Role
    let role;
    if (intelliFiberUserRoles && intelliFiberUserRoles.length > 0) {
      console.log('$$$USER :', lUser);
      role = intelliFiberUserRoles.find(
        (item) => item.UserID === lUser?.userID
      );
      console.log('$$$USER Role:', role);
      if (role) {
        console.log('$$$Return USER Role:', role);
        return projects ? projects : [];
      }
    }
    console.log('$$$USER projectRoles:', intelliFiberProjectUserRoles);
    if (
      !role &&
      intelliFiberProjectUserRoles &&
      intelliFiberProjectUserRoles.length > 0
    ) {
      const projectRoles = intelliFiberProjectUserRoles
        .filter((item) => item.UserID === lUser?.userID)
        .map((item) => item.ProjectID);
      console.log('$$$USER projectRoles:', projectRoles);
      const filteredProjects = projects?.filter((item) =>
        projectRoles.includes(item.ID)
      );
      console.log('$$$USER filteredProjects:', filteredProjects);
      return filteredProjects ? filteredProjects : [];
    }

    return [];
  };

  useEffect(() => {
    console.log('Projects set:', projects);

    if (projects && projects.length > 0 && user) {
      //Filter Projects
      //getAccessibleProjects
      const filteredProject = getAccessibleProjects(user);
      setProjectList(filteredProject);
    }
    //eslint-disable-next-line
  }, [projects, projects?.length, user]);

  useEffect(() => {
    console.log('Alert Message:', alertMessage, 'Alert Title', alertTitle);

    //eslint-disable-next-line
  }, [displayAlert]);

  const closeAlert = () => {
    if (clearAlert) clearAlert();
  };
  return (
    <Fragment>
      {displayAlert && alertUI === 'dialog' && (
        <AlertDialog
          message={alertMessage ? alertMessage : ''}
          title={alertTitle ? alertTitle : ''}
          handleClose={closeAlert}
        />
      )}
      {displayAlert && alertUI === 'snack' && (
        <Alert
          message={alertMessage ? alertMessage : ''}
          type={messageType ? messageType : 'success'}
        />
      )}
      {displayAlert && alertUI === 'confirm' && (
        <AlertDialog
          message={alertMessage ? alertMessage : ''}
          title={alertTitle ? alertTitle : ''}
          handleClose={closeAlert}
          handleSubmit={submitAction}
          type='warning'
        />
      )}
      {showApp ? (
        <ThemeProvider theme={theme}>
          <Grid
            container
            direction='column'
            justifyContent='flex-start'
            alignItems='stretch'
          >
            <Grid
              xs
              className='header-pane'
              sx={{ backgroundColor: '#366aaf' }}
            >
              <NavBar />
            </Grid>
            <Grid
              container
              className='main-pane'
              direction='row'
              justifyContent='center'
            >
              <Routes>
                <Route
                  path='/'
                  element={<UserProjects projects={projectList} search={''} />}
                />
                <Route path='/project' element={<ProjectNavbar />}>
                  {/* <Route index element={<ProjectNavbar />} /> */}
                  {/* <Route path="details/:id" element={<ProjectDetails />} /> */}
                  <Route path='details/:id' element={<NewDetailsPage />} />
                  <Route path='areas/:id' element={<UpdateServiceArea />} />
                  <Route path='units/:id' element={<UpdateUnitsConfig />} />
                  <Route path='roles/:id' element={<UpdateRolesConfig />} />
                  <Route path='workflow/:id' element={<ServiceAreas />} />
                  <Route path='links/:id' element={<QuickLinks />} />
                </Route>
                <Route path='/new-project' element={<ProjectInformation />} />
                <Route path='/config' element={<ConfigNavbar />}>
                  {/* <Route index element={<ProjectNavbar />} /> */}
                  <Route
                    path='roles'
                    element={<UpdateIntelliFiberRolesConfig />}
                  />
                  <Route
                    path='units'
                    element={<UpdateIntelliFiberUnitsConfig />}
                  />
                  <Route
                    path='clients'
                    element={<UpdateIntelliFiberClientsConfig />}
                  />
                  <Route
                    path='client-user'
                    element={<UpdateIntelliFiberClientsUserConfig />}
                  />
                  <Route
                    path='client-group'
                    element={<UpdateIntelliFiberClientGroupConfig />}
                  />
                </Route>
              </Routes>
            </Grid>
          </Grid>
        </ThemeProvider>
      ) : (
        <Grid container justifyContent='center' alignItems='center'>
          <Loader />
        </Grid>
      )}
    </Fragment>
  );
}

export default App;
